// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--JC70K","descriptionLog":"descriptionLog--zpF_n","markerAnimationScale":"markerAnimationScale--AGY6_"};